import React, { createContext, useState, useEffect } from 'react';

// Create the AuthContext with default value null (no user logged in)
export const leaveContext = createContext(null);

export const LeaveProvider = ({ children }) => {
  const [leave, setLeave] = useState(() => {
    // Load the initial state from localStorage
    const savedLeave = localStorage.getItem('leave');
    return savedLeave ? JSON.parse(savedLeave) : null;
  });

  const setLeaveDetail = (data) => {
    setLeave(data);
    // Save the value to localStorage
    sessionStorage.setItem('leave', JSON.stringify(data));
  };

  const clearleave = () => {
    setLeave(null);
    // Remove the value from localStorage
    sessionStorage.removeItem('leave');
  };

  useEffect(() => {
    // Sync the leave state with localStorage on mount
    const savedLeave = sessionStorage.getItem('leave');
    if (savedLeave) {
      setLeave(JSON.parse(savedLeave));
    }
  }, []);

  return (
    <leaveContext.Provider value={{ leave, setLeaveDetail, clearleave }}>
      {children}
    </leaveContext.Provider>
  );
};
